export class CatalogAccordionEvents {
  static OPEN_ACCORDION = 'openCatalogAccordion'

  static openAccordion() {
    window.dispatchEvent(new CustomEvent(CatalogAccordionEvents.OPEN_ACCORDION))
  }
}
